import { render, staticRenderFns } from "./wechat_live.vue?vue&type=template&id=424a2a5c&scoped=true&"
import script from "./wechat_live.vue?vue&type=script&lang=js&"
export * from "./wechat_live.vue?vue&type=script&lang=js&"
import style0 from "./wechat_live.vue?vue&type=style&index=0&id=424a2a5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a2a5c",
  null
  
)

export default component.exports